import PropTypes from "prop-types";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Checkbox, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import clsx from "clsx";
import { Field } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const AppInput = ({
  name,
  label,
  type,
  placeholder,
  disabled,
  required,
  hideLabel,
  hideError,
  error,
  touched,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("global");

  const [showPassword, setShowPassword] = useState(false);

  const checkType =
    type === "text" || type === "number" || type === "email" || type === "password";

  const OtherTypeComponent = type === "textArea" ? TextArea : Checkbox;

  return (
    <div
      style={{
        display: checkType || type === "textArea" ? "block" : "flex",
        width: type !== "checkbox" ? "100%" : "auto",
        position: "relative",
        marginBottom: "15px",
      }}
    >
      {!hideLabel && (
        <label htmlFor={name}>
          {t(label)} {required && "*"}
        </label>
      )}
      <div className="relative">
        <Field
          as={checkType ? Input : OtherTypeComponent}
          name={name}
          type={showPassword ? "text" : type || "text"}
          placeholder={t(placeholder)}
          size="large"
          disabled={disabled}
          autoComplete={type === "password" ? "new-password" : "off"}
          spellCheck={false}
        />
        {type === "password" && (
          <Icon
            icon={showPassword ? "mdi:eye-off" : "mdi:eye"}
            className={clsx(
              "absolute top-1/2 -translate-y-1/2 cursor-pointer",
              {
                "right-2": language === "en",
                "left-2": language === "ar",
              }
            )}
            onClick={() => setShowPassword(!showPassword)}
          />
        )}
      </div>
      {!hideError && error && touched && (
        <p className="text-text_warning text-sm mt-1 text-start">{t(error)}</p>
      )}
    </div>
  );
};

AppInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    "text",
    "number",
    "email",
    "password",
    "textArea",
    "checkbox",
  ]),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  touched: PropTypes.bool,
  hideLabel: PropTypes.bool,
  hideError: PropTypes.bool,
};

AppInput.defaultProps = {
  type: "text",
  placeholder: "",
  disabled: false,
  required: false,
  error: "",
  touched: false,
  hideLabel: false,
  hideError: false,
};

export default AppInput;
